import React from 'react';

import { BaseButton } from '@components/primitives';
import { SimpleCircleSpinner } from '@components/spinners';

import type { AcceptButtonProperties } from './AcceptButton.types';

export const AcceptButton: React.FC<AcceptButtonProperties> = ({
  dataTest = 'accept_button',
  onClick,
  isSubmitting,
  disabled,
  color,
  label,
  form,
  type = 'button',
  sx,
}) => {
  const handleClick = React.useCallback(() => {
    onClick?.();
  }, [onClick]);
  return (
    <BaseButton
      dataTest={dataTest}
      id={dataTest}
      color={color}
      variant='contained'
      type={type}
      onClick={handleClick}
      disabled={isSubmitting || disabled}
      size='large'
      form={form}
      startIcon={<SimpleCircleSpinner size='20' isLoading={isSubmitting} />}
      sx={{ width: '100%', ...sx }}
    >
      {isSubmitting ? (label ?? 'Отправляется...') : (label ?? 'Отправить')}
    </BaseButton>
  );
};
